module.exports = __webpack_public_path__ + "static/media/hotcategory-icon.98d03f0c.svg";